import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.values.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { TASTING_PHOTOS } from "@/js/lists.ts";
import Error from "@/views/error/error.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import TastingPhotoRequiredFormModal from "@/components/tasting-photos/TastingPhotoRequiredFormModal.vue";
import TastingPhotoFormModal from "@/components/tasting-photos/TastingPhotoFormModal.vue";
import TastingPhotoUploadFormModal from "@/components/tasting-photos/TastingPhotoUploadFormModal.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var requiredFiltersStatus = Object.values(TASTING_PHOTOS.REQUIRED.STATUS);
var takenFiltersStatus = Object.values(TASTING_PHOTOS.TAKEN.STATUS);
export default {
  name: "AdminTastingPhotos",
  components: {
    Error: Error,
    Confirm: Confirm,
    TastingPhotoRequiredFormModal: TastingPhotoRequiredFormModal,
    TastingPhotoFormModal: TastingPhotoFormModal,
    TastingPhotoUploadFormModal: TastingPhotoUploadFormModal,
    ErrorModal: ErrorModal
  },
  props: ["loggedUserData"],
  data: function data() {
    return {
      hasAccessToPage: true,
      tab: null,
      required: {
        formSearch: {
          userIds: [],
          wineIds: [],
          allowedStatus: [TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id, TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id]
        },
        lastSearch: {
          userIds: null,
          wineIds: null,
          allowedStatus: null
        },
        filters: {
          users: [],
          wines: [],
          allowedStatus: requiredFiltersStatus
        },
        results: {
          headers: [{
            text: "User",
            value: "user.fullName",
            align: "left"
          }, {
            text: "Wine",
            value: "wine",
            align: "left"
          }, {
            text: "Reference",
            value: "fromReference",
            align: "left",
            cellClass: "text-nowrap"
          }, {
            text: "Nb remaining",
            value: "nbBottlesRemaining",
            align: "center"
          }, {
            text: "Date",
            value: "deliveredDate",
            align: "center",
            cellClass: "text-nowrap"
          }, {
            text: "Nb init",
            value: "nbBottlesInit",
            align: "center"
          }, {
            text: "",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap",
            sortable: false
          }],
          items: [],
          totalCount: null
        },
        isSearchPending: false,
        cancellationTokenSearch: null,
        isFiltersPending: false,
        cancellationTokenFilters: null,
        editedId: null
      },
      taken: {
        formSearch: {
          orderIds: [],
          targetedUserIds: [],
          wineIds: [],
          allowedStatus: [TASTING_PHOTOS.TAKEN.STATUS.TO_TRANSFER.id]
        },
        lastSearch: {
          orderIds: null,
          targetedUserIds: null,
          wineIds: null,
          allowedStatus: null
        },
        filters: {
          orders: [],
          targetedUsers: [],
          wines: [],
          allowedStatus: takenFiltersStatus
        },
        results: {
          headers: [{
            text: "Date",
            value: "creationDate",
            align: "center",
            cellClass: "text-nowrap"
          }, {
            text: "User",
            value: "users",
            align: "left"
          }, {
            text: "Product & origin",
            value: "contents",
            align: "left"
          }, {
            text: "Status",
            value: "status",
            align: "center",
            cellClass: "text-nowrap",
            sortable: false
          }, {
            text: "",
            value: "actions",
            align: "right",
            cellClass: "text-nowrap",
            sortable: false
          }],
          items: [],
          totalCount: null
        },
        isSearchPending: false,
        cancellationTokenSearch: null,
        isFiltersPending: false,
        cancellationTokenFilters: null,
        editedId: null
      },
      upload: {
        isComponentCreated: false,
        tastingPhotoRequiredId: null
      },
      TASTING_PHOTOS: TASTING_PHOTOS,
      ERROR_DATA: ERROR_DATA
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this2$$route$query, _this2$$route$query2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.hasAccessToPage = hasRole(process.env.VUE_APP_ROLES_MANAGE_TASTING_PHOTOS);
            if (_this2.hasAccessToPage) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            if (((_this2$$route$query = _this2.$route.query) === null || _this2$$route$query === void 0 ? void 0 : _this2$$route$query.tab) === "taken") {
              _this2.tab = 1;
            } else if (((_this2$$route$query2 = _this2.$route.query) === null || _this2$$route$query2 === void 0 ? void 0 : _this2$$route$query2.tab) === "required") {
              _this2.tab = 0;
              if (+_this2.$route.query.wineId) {
                _this2.required.formSearch.wineIds = [+_this2.$route.query.wineId];
              }
            }
            _this2.getRequiredFilters();
            _this2.requiredSearch();
            _this2.getTakenFilters();
            _this2.takenSearch();
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    requiredSearch: function requiredSearch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this$required$cancel, _this3$required$resul;
        var _this, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.required.isSearchPending = true;
              _this3.required.results.items = [];
              _this3.required.results.totalCount = 0;
              _this3.required.lastSearch = _objectSpread({}, _this3.required.formSearch);
              _this = _this3;
              (_this$required$cancel = _this.required.cancellationTokenSearch) === null || _this$required$cancel === void 0 || _this$required$cancel.cancel();
              _this.required.cancellationTokenSearch = axios.CancelToken.source();
              paramsQuery = Object.encodeToUri(_this3.required.formSearch);
              _context2.next = 10;
              return request("/v1/tasting-photos/required?params=".concat(paramsQuery), "get", null, true, "api", null, _this.required.cancellationTokenSearch).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.required.isSearchPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load required photos.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context2.sent;
              _this3.required.results.items = _toConsumableArray(response.data.value);
              _this3.required.results.totalCount = +((_this3$required$resul = _this3.required.results.items) === null || _this3$required$resul === void 0 ? void 0 : _this3$required$resul.length);
              _this3.required.isSearchPending = false;
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getRequiredFilters: function getRequiredFilters() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this$required$cancel2, _this4$required$filte, _this4$required$filte2;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.required.isFiltersPending = true;
              _this4.required.filters.users = [];
              _this4.required.filters.wines = [];
              _this = _this4;
              (_this$required$cancel2 = _this.required.cancellationTokenFilters) === null || _this$required$cancel2 === void 0 || _this$required$cancel2.cancel();
              _this.required.cancellationTokenFilters = axios.CancelToken.source();
              _context3.next = 8;
              return request("/v1/tasting-photos/required/filters", "get", null, true, "api", null, _this.required.cancellationTokenFilters).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.required.isFiltersPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to laod filters for required photos.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 8:
              response = _context3.sent;
              _this4.required.filters = _objectSpread(_objectSpread({}, response.data.value), {}, {
                allowedStatus: requiredFiltersStatus
              });
              _this4.required.filters.wines = (_this4$required$filte = (_this4$required$filte2 = _this4.required.filters.wines) === null || _this4$required$filte2 === void 0 ? void 0 : _this4$required$filte2.map(function (x) {
                return {
                  id: x.id,
                  name: "".concat(x.name, " - ").concat(x.namingData.sku)
                };
              })) !== null && _this4$required$filte !== void 0 ? _this4$required$filte : [];
              _this4.required.isFiltersPending = false;
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    requiredRowClick: function requiredRowClick(item) {
      var _this5 = this;
      if (!item.isBusy) {
        this.required.editedId = item.id;
        this.$nextTick(function () {
          _this5.$refs.tastingPhotoRequiredForm.open();
        });
      }
    },
    requiredConfirmCancel: function requiredConfirmCancel(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.$refs.confirm.open("Cancel required photo", "Are you sure to cancel the requirement of a tasting photo for this product ? Warning: This action cannot be undone.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(confirm) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!confirm) {
                          _context4.next = 3;
                          break;
                        }
                        _context4.next = 3;
                        return _this6.requiredCancel(item);
                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    requiredCancel: function requiredCancel(item) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this7;
              item.isBusy = true;
              _context7.next = 4;
              return request("/v1/tasting-photos/required/" + item.id, "delete", {}, true, "api").catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        item.isBusy = false;
                        errorData = getErrorData(e, {}, "Unable to cancel the required tasting photo.");
                        handleErrorData(_this, errorData);
                        throw e;
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 4:
              item.isBusy = false;
              _this7.requiredSearch();
              _this7.$toasted.show("Required tasting photo cancelled.", {
                type: "success"
              });
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getUploadPhotoRoute: function getUploadPhotoRoute(item) {
      var routeParams = {};
      return {
        name: "adminOrderSummary",
        params: {
          id: item.id,
          routeParams: routeParams
        }
      };
    },
    requiredGetStatusClass: function requiredGetStatusClass(item) {
      if (item.status === TASTING_PHOTOS.REQUIRED.STATUS.TO_TAKE.id) return "fill-empty";
      if (item.status === TASTING_PHOTOS.REQUIRED.STATUS.PARTIALLY_TAKEN.id) return "fill-info";
      if (item.status === TASTING_PHOTOS.REQUIRED.STATUS.FULLY_TAKEN.id) return "fill-sucess";
      if (item.status === TASTING_PHOTOS.REQUIRED.STATUS.CANCELLED.id) return "fill-danger";
      return "fill-empty";
    },
    takenSearch: function takenSearch() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this$taken$cancellat, _this8$taken$results$;
        var _this, paramsQuery, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.taken.isSearchPending = true;
              _this8.taken.results.items = [];
              _this8.taken.results.totalCount = 0;
              _this8.taken.lastSearch = _objectSpread({}, _this8.taken.formSearch);
              _this = _this8;
              (_this$taken$cancellat = _this.taken.cancellationTokenSearch) === null || _this$taken$cancellat === void 0 || _this$taken$cancellat.cancel();
              _this.taken.cancellationTokenSearch = axios.CancelToken.source();
              paramsQuery = Object.encodeToUri(_this8.taken.formSearch);
              _context8.next = 10;
              return request("/v1/tasting-photos?params=".concat(paramsQuery), "get", null, true, "api", null, _this.taken.cancellationTokenSearch).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.taken.isSearchPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load taken photos.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 10:
              response = _context8.sent;
              _this8.taken.results.items = _toConsumableArray(response.data.value);
              _this8.taken.results.totalCount = +((_this8$taken$results$ = _this8.taken.results.items) === null || _this8$taken$results$ === void 0 ? void 0 : _this8$taken$results$.length);
              _this8.taken.isSearchPending = false;
            case 14:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getTakenFilters: function getTakenFilters() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this$taken$cancellat2, _this9$taken$filters$, _this9$taken$filters$2;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this9.taken.isFiltersPending = true;
              _this9.taken.filters.orders = [];
              _this9.taken.filters.targetedUsers = [];
              _this9.taken.filters.wines = [];
              _this = _this9;
              (_this$taken$cancellat2 = _this.taken.cancellationTokenFilters) === null || _this$taken$cancellat2 === void 0 || _this$taken$cancellat2.cancel();
              _this.taken.cancellationTokenFilters = axios.CancelToken.source();
              _context9.next = 9;
              return request("/v1/tasting-photos/filters", "get", null, true, "api", null, _this.taken.cancellationTokenFilters).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.taken.isFiltersPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load filters for taken photos.");
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 9:
              response = _context9.sent;
              _this9.taken.filters = _objectSpread(_objectSpread({}, response.data.value), {}, {
                allowedStatus: takenFiltersStatus
              });
              _this9.taken.filters.wines = (_this9$taken$filters$ = (_this9$taken$filters$2 = _this9.taken.filters.wines) === null || _this9$taken$filters$2 === void 0 ? void 0 : _this9$taken$filters$2.map(function (x) {
                return {
                  id: x.id,
                  name: "".concat(x.name, " - ").concat(x.namingData.sku)
                };
              })) !== null && _this9$taken$filters$ !== void 0 ? _this9$taken$filters$ : [];
              _this9.taken.isFiltersPending = false;
            case 13:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    takenRowClick: function takenRowClick(item) {
      var _this10 = this;
      if (!item.isBusy) {
        this.taken.editedId = item.id;
        this.$nextTick(function () {
          _this10.$refs.tastingPhotoTakenForm.open();
        });
      }
    },
    takenGetStatusClass: function takenGetStatusClass(item) {
      if (item.status === TASTING_PHOTOS.TAKEN.STATUS.TO_TRANSFER.id) return "fill-info";
      if (item.status === TASTING_PHOTOS.TAKEN.STATUS.TRANSFERRED.id) return "fill-success";
      if (item.status === TASTING_PHOTOS.TAKEN.STATUS.CANCELLED.id) return "fill-danger";
      return "fill-empty";
    },
    openUpload: function openUpload(item) {
      var _this11 = this;
      this.upload.tastingPhotoRequiredId = item === null || item === void 0 ? void 0 : item.id;
      this.upload.isComponentCreated = true;
      this.$nextTick(function () {
        _this11.$refs.tastingPhotoUploadForm.open();
      });
    },
    closeUpload: function closeUpload() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this12.upload.isComponentCreated = false;
              _this12.requiredSearch();
              _this12.takenSearch();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    }
  }
};